/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";
import { Space, Modal, Row, Col, Image } from "antd";
import { Button } from "@mui/material";
import CloseIcon from "../../../../assets/images/icon_menus/Close Button.svg";
import { Document, Page } from 'react-pdf';
import printJS from 'print-js'
import { idNamingConversion } from "../../../../helpers/utilities";


const InvoicePDFViewer = React.forwardRef((props, ref) => {
    const { open, fileUri, link, history, handleClose, preview, type } = props;
    //const [languageId, setLanguageId] = useState(details?.customer?.languageId);
    const pdfExportComponent = useRef(null);
    const classes = customStyles();
    const [numPages, setNumPages] = useState();
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();

    const closeHandleCancel = () => {
        if (link !== '') {
            history.push(link, type);
        } else {
            handleClose(!open)
        }
    };

    const handleDownload = () => {
        var w = window.open(fileUri);
        w.document.title = 'testing';
    }

    return (
        <Modal title="" open={true} footer={null}
            onCancel={closeHandleCancel}
            width={1030}
            closable={false}
            className={clsx(classes.invoiceDesign, classes.invoiceDesignPreview, classes.removeUnderline)}>
            <Row gutter={75} className={classes.invoiceHeader}>
                <Col span={5}>
                </Col>
                <Col span={5}>
                </Col>
                <Col span={14} className={clsx(classes.textAlignRight, classes.fontSize0)}>
                    <Space direction="horizontal" align="center" size={[20, 20]}>
                        {
                            !preview &&
                            <>
                                <Button
                                    key="confirm"
                                    color="primary"
                                    id={idNamingConversion('Print', 'common', 'Button')}
                                    variant="contained"
                                    onClick={() => printJS(fileUri)}
                                    className={clsx(classes.AddMoreBtn)}
                                >Print</Button>
                                <Button
                                    key="save"
                                    color="primary"
                                    variant="contained"
                                    id={idNamingConversion('Download', 'common', 'Button')}
                                    onClick={() => handleDownload()}
                                    className={clsx(classes.modalBtn)}
                                >Download</Button>
                            </>
                        }
                        <Image id={idNamingConversion('Close', 'common', 'Icon')} onClick={() => closeHandleCancel()} src={CloseIcon} preview={false} className={classes.cursor} />
                    </Space>
                </Col>
            </Row>
            <div style={{ fontFamily: "Roboto" }} className={classes.divToPrint} id={"divToPrint"}>
                <Document inputRef={pdfExportComponent} file={fileUri} className={classes.customPdfViewer}
                    onLoadSuccess={({ numPages }) => {
                        setNumPages(numPages);
                        setWidth(pdfExportComponent?.current?.offsetWidth);
                        setHeight(pdfExportComponent?.current?.offsetHeight);
                    }}>
                    {Array.apply(null, Array(numPages))
                        .map((x, i) => i + 1)
                        .map(page => <Page size="A4" width={width} height={height} pageNumber={page} />)}
                </Document>


            </div>
        </Modal>
    );
});

export default InvoicePDFViewer;
